"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var util_1 = require("@aperza/util");
// @ts-ignore
var react_autocomplete_1 = __importDefault(require("react-autocomplete"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var client_1 = require("@apollo/client");
var ui_1 = require("@aperza/ui");
var UseTd_1 = __importDefault(require("../../hook/UseTd"));
var appConfig = util_1.AppService.appConfig();
// const SUGGEST_SEARCH = gql`
//   query SuggestSearchQuery($keyword: String, $langCode: String) {
//     suggestSearch {
//       search(keyword: $keyword, langCode: $langCode) {
//         productKeyword
//         productType
//       }
//     }
//   }
// `;
exports.SUGGEST_SEARCH = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query SuggestSearchQuery($keyword: String, $langCode: String) {\n    suggestSearch(keyword: $keyword, langCode: $langCode) {\n      productKeyword\n      productType\n    }\n  }\n"], ["\n  query SuggestSearchQuery($keyword: String, $langCode: String) {\n    suggestSearch(keyword: $keyword, langCode: $langCode) {\n      productKeyword\n      productType\n    }\n  }\n"])));
/**
 * There are 2 modes
 *
 * If onSuggestChange is null, Suggest will independently handle the keyword change.
 *
 * If onSuggestChange is NOT null, keyword change will be handled by the parent component.
 * If the parent component has more than one Suggest component which must have the same keyword,
 * the parent component must handle the keyword change in order to synchronize the keyword value across
 * multiple Suggest components.
 */
exports.Suggest = function (props) {
    var locale = appConfig.langCode;
    var getKeyword = function () {
        return util_1.AppConfigService.getSearchKeyword() ? util_1.AppConfigService.getSearchKeyword() : '';
    };
    var onSuggestChange = props.onSuggestChange, suggestKeyword = props.suggestKeyword, inputClassName = props.inputClassName, rfType = props.rfType;
    var _a = react_1.useState(onSuggestChange ? suggestKeyword : getKeyword()), keyword = _a[0], setKeyword = _a[1];
    var _b = react_1.useState(false), isIME = _b[0], setIsIME = _b[1];
    var _c = react_1.useState(), timerID = _c[0], setTimerID = _c[1];
    var _d = client_1.useQuery(exports.SUGGEST_SEARCH, {
        variables: {
            langCode: locale,
            keyword: keyword || '',
        },
        fetchPolicy: 'cache-first',
    }), data = _d.data, refetch = _d.refetch;
    var refreshQuery = function () {
        var appConfig = util_1.AppService.appConfig();
        if ([util_1.AppConfig.APERZA_SEARCH, util_1.AppConfig.APERZA_EC].includes(appConfig.serviceType)) {
            return refetch({ langCode: locale, keyword: keyword });
        }
    };
    react_1.useEffect(function () {
        setKeyword(suggestKeyword);
    }, [suggestKeyword]);
    react_1.useEffect(function () {
        //https://aperza.atlassian.net/browse/AB-5486
        if (!util_1.AppConfigService.isAperzaSearchCatalogResultPage() &&
            !util_1.AppConfigService.isAperzaSearchItemResultPage() &&
            !util_1.AppConfigService.isAperzaSearchNewsResultPage() &&
            !util_1.AppConfigService.shouldShowMarketplaceTopBanner()) {
            clearTimeout(timerID);
            setTimerID(setTimeout(refreshQuery, 750));
        }
    }, [keyword]);
    var search = UseTd_1.default().search;
    var onChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedKeyword;
        var _a;
        return __generator(this, function (_b) {
            updatedKeyword = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
            setKeyword(updatedKeyword ? updatedKeyword : '');
            if (onSuggestChange) {
                onSuggestChange(updatedKeyword);
            }
            return [2 /*return*/];
        });
    }); };
    var onSelect = function (val) { return __awaiter(void 0, void 0, void 0, function () {
        var _rfType, pathname, origin_1, searchWebHost, langCode, encodedVal, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(val && val.length > 0)) return [3 /*break*/, 2];
                    _rfType = props.rfType ? props.rfType : '1101';
                    pathname = util_1.AppConfigService.getPath();
                    origin_1 = util_1.AppConfigService.getOrigin();
                    searchWebHost = appConfig.searchWebHost;
                    langCode = appConfig.langCode;
                    encodedVal = encodeURIComponent(val);
                    url = '#';
                    if (util_1.PathUtil.isSearchCatalogPage(pathname, langCode) ||
                        util_1.PathUtil.isCatalogPage(pathname, langCode) ||
                        appConfig.isAperzaCatalog) {
                        url = searchWebHost + "/" + langCode + "/s/catalog/?k=" + encodedVal + "&rf=" + _rfType + "&ss=1";
                    }
                    else if (appConfig.serviceType === util_1.AppConfig.APERZA_NEWS) {
                        url = origin_1 + "/?s=" + encodeURIComponent(val);
                    }
                    else if (pathname.startsWith("/" + langCode + "/s/news/")) {
                        url = searchWebHost + "/" + langCode + "/s/news/?k=" + encodedVal + "&rf=" + _rfType + "&ss=1";
                    }
                    else {
                        url = searchWebHost + "/" + langCode + "/s/model/?k=" + encodedVal + "&rf=" + _rfType + "&ss=1";
                        if (util_1.AppConfigService.shouldShowMarketplaceTopBanner() || !props.disableMarketplaceBanner) {
                            url = "https://ec" + appConfig.baseComDomain + "/" + langCode + "/s/item/?k=" + encodedVal + "&rf=" + _rfType + "&ss=1";
                        }
                    }
                    return [4 /*yield*/, search(props.tdId, val, url)];
                case 1:
                    _a.sent();
                    window.location.href = url;
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var onClickSuggestButton = function () { return __awaiter(void 0, void 0, void 0, function () {
        var val;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    val = keyword;
                    return [4 /*yield*/, onSelect(val.trim())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onInputKeyDown = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.key === 'Enter' && !isIME)) return [3 /*break*/, 2];
                    return [4 /*yield*/, onClickSuggestButton()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var onCompositionStart = function () {
        setIsIME(true);
    };
    var onCompositionEnd = function () {
        setIsIME(false);
    };
    var isMainPage = util_1.AppService.isMainPage();
    var isSearchResult = util_1.AppConfigService.isAperzaSearchResultPage();
    var isSearchNewsResult = util_1.AppConfigService.isAperzaSearchNewsResultPage();
    var getWrapperStyle = function () {
        var wrapperStyle = {
            display: 'inline-block',
            position: 'relative',
        };
        if (onSuggestChange) {
            wrapperStyle.width = '100%';
        }
        return wrapperStyle;
    };
    var getItems = function () {
        var items = [];
        if (data && data.suggestSearch && Array.isArray(data.suggestSearch)) {
            items = data.suggestSearch.map(function (product) {
                return {
                    label: product.productKeyword,
                    productType: product.productType,
                };
            });
        }
        return items;
    };
    return (react_1.default.createElement("div", { className: "suggest-container" },
        react_1.default.createElement(react_autocomplete_1.default, { getItemValue: function (item) { return item.label; }, items: getItems(), wrapperStyle: getWrapperStyle(), renderInput: function (_props) {
                return (react_1.default.createElement("div", { className: "suggest-input-container " + (isSearchResult || isSearchNewsResult ? 'search-result' : '') },
                    react_1.default.createElement("div", { className: "suggest-input " + (isMainPage ? 'aw-main-page' : '') },
                        onSuggestChange && !isSearchResult && !isSearchNewsResult && false && (react_1.default.createElement(ui_1.WebMediaQuery, { mobileOnly: true },
                            react_1.default.createElement("i", { className: "fa fa-search", "aria-hidden": "true" }))),
                        rfType === '1102' && (react_1.default.createElement("div", { className: "suggest-input-note" },
                            react_1.default.createElement(ui_1.Message, { messageId: "suggest.title" }))),
                        react_1.default.createElement("input", __assign({ type: "text", className: inputClassName }, _props, { onKeyDown: onInputKeyDown, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd }))),
                    react_1.default.createElement("button", { className: "suggest-button " + inputClassName + " " + (isSearchResult || isSearchNewsResult ? 'search-result' : ''), onClick: onClickSuggestButton, type: "button" },
                        react_1.default.createElement("i", { className: "fa fa-search", "aria-hidden": "true" }))));
            }, renderMenu: function (items) {
                if (items.length > 0) {
                    return (react_1.default.createElement("div", { className: "suggest-list " + (isMainPage ? 'aw-main-page' : '') }, items));
                }
                return react_1.default.createElement("div", { style: { display: 'none' } });
            }, renderItem: function (item, isHighlighted) { return (react_1.default.createElement("div", { key: item.label, style: { background: isHighlighted ? 'lightgray' : 'white' }, className: "suggest-item" },
                react_1.default.createElement("span", { className: "name" }, item.label),
                react_1.default.createElement("span", { className: "category" }, item.productType))); }, value: keyword, onChange: onChange, onSelect: onSelect })));
};
exports.Suggest.defaultProps = {
    inputClassName: '',
};
exports.default = exports.Suggest;
var templateObject_1;
